<template>
    <div class="page wallet">
        <div class="title">        
            <mu-appbar class="center">
                <!--<router-link slot="left" to="/search/makeOrder"><mu-icon value="keyboard_arrow_left" color="white"/></router-link>-->
                <router-link slot="left" to="/home/index"><mu-icon value="keyboard_arrow_left" color="white"/></router-link>
                <span class="topT left">提示</span>
            </mu-appbar> 
        </div>
        <div class="main">
            <mu-icon value="check_outline" color="#27ba69" :size="50"/><br/>
            <p>订单提交成功!</p>
        </div>
        
        <div class='content'>
            <mu-divider/>
                <div class='inner'>
                    如您到店较晚，建议您先支付房费，我们将一直为您保留房间至<span class='mark'>【退房当日】&nbsp;12:00</span>，期间可随时入住。<br/>
                    <span class='mark'>{{g_searchParam.startDate}}&nbsp;18:00</span>之前取消订单可全额退款。超时或未入住将收取您首日房费。
                </div>  
            <mu-divider/>
        </div>
        <div class='btns'>
            <mu-raised-button @click='toOrder' label="取消预订" class="btn btn1" />
            <mu-raised-button v-if='g_PayOrder.BookType == 0 && g_PayOrder.Money > 0'  @click='toPay' label="支付房费" class="btn btn2" primary/>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import "../../assets/theme.less";
    .page{
        background-color:white;
        .main{
            padding:2.5em;
            text-align:center;
            p{
                color:@primaryColor;
                font-size:18px;
            }
        }
        .content{
            color:@secondBlack;
            margin:15px;
            .inner{
                margin:15px 10px;
                font-size:0.25rem;
                line-height:0.47rem;
                .mark{
                    color:@primaryOrange;
                }
            }
        }
        .btn1{
            color:white;
            width:3rem;
        }
        .btn{
            color:white;
            width:3.4rem;
            height:1rem;
            margin:auto;
        }
        .btns{
            text-align:center;
            .btn1{
                background-color:#CCCCCC
            }
        }

    }
</style>
<script>
import { mapGetters } from 'vuex'
export default {
    methods: {
        toOrder(){
            this.$router.push({ path: '/home/order' })
        },
        toPay(){
            this.$router.push({ path: '/order/PayMoney' })
        }
    }
    ,
    computed: {
        ...mapGetters([
        'g_currentInfo','g_searchParam','g_city','g_PayOrder'
        ]),
    },
}
</script>


// WEBPACK FOOTER //
// orderSuccess.vue?fda7728a